import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService , DataUtils } from 'ng-jhipster';

import { MarketdateExpense } from './marketdate-expense.model';
import { MarketdateExpenseService } from './marketdate-expense.service';

@Component({
    selector: 'jhi-marketdate-expense-detail',
    templateUrl: './marketdate-expense-detail.component.html'
})
export class MarketdateExpenseDetailComponent implements OnInit, OnDestroy {

    marketdateExpense: MarketdateExpense;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private dataUtils: DataUtils,
        private marketdateExpenseService: MarketdateExpenseService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['marketdateExpense', 'expenseType']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInMarketdateExpenses();
    }

    load(id) {
        this.marketdateExpenseService.find(id).subscribe((marketdateExpense) => {
            this.marketdateExpense = marketdateExpense;
        });
    }
    byteSize(field) {
        return this.dataUtils.byteSize(field);
    }

    openFile(contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInMarketdateExpenses() {
        this.eventSubscriber = this.eventManager.subscribe('marketdateExpenseListModification', (response) => this.load(this.marketdateExpense.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-expense/marketdate-expense-detail.component.ts